<template>
  <div class="mt-4" :busy="isLoading">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? (width || '100%') : 'auto' }">
      <div
        :style="{
          'overflow-y': !(items.length > (communication_types.length || 5))
            ? 'visible'
            : 'auto',
          'margin-bottom': saveRelationBtn ? '1rem' : '',
          'max-height': saveRelationBtn ? '500px !important' : '',
        }"
      >
        <p class="font-weight-bold" v-if="!isLoading && getGroupId()">
          {{ coord }}
        </p>
        <b-table
          :busy="isLoading"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          :tbody-tr-class="rowClass"
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <!-- <template #cell()="data">
            {{ data.unformatted }}
          </template> -->
          <template
            v-slot:head(check)="data"
            v-if="hasChecks && !isCheckExclusive && items.length"
          >
            <base-checkbox
              v-model="checkAll"
              name="all"
              class="check"
              groupLabel=""
              :label="data.label"
              @change="
                $emit('interaction');
                onSelectAllRows();
              "
            >
            </base-checkbox>
          </template>
          <template #cell(check)="row" v-if="hasChecks">
            <base-checkbox
              name="check"
              class="check"
              v-model="row.item.check"
              @input="
                $emit('interaction');
                onSelectRow($event, row.index, row.item);
              "
            />
          </template>
          <template #cell(radio_check)="row" v-if="hasChecks">
            <base-checkbox
              name="check"
              class="check"
              v-model="row.item.check"
              @input="
                $emit('interaction');
                onRadioSelectRow($event, row.index, row.item);
              "
            />
          </template>
          <template #cell(customer)="{ item }" v-if="items.length">
            <span
              v-if="
                !Array.isArray(item.attributables) && !item.attributables.length
              "
            >{{
                item.status_registry.value === 1
                  ? item.attributables.CNAM
                  : item.attributables.SURN + " " + item.attributables.NAME
              }}</span
            >
          </template>
          <template #cell(localita)="{ item }" v-if="items.length">
            <div v-if="item['correspondences']">
              {{
                `${toRelationString(
                  "correspondences",
                  item.correspondences,
                  ["CITY"],
                  [0]
                )} (${toRelationString(
                  "correspondences",
                  item.correspondences,
                  ["VIRTUAL_CITY_PROVINCE"],
                  [0]
                )})`
              }}
            </div>
          </template>
          <template #cell(code)="{ item }" v-if="items.length">
            {{
              item.registry_groups
                ? item.registry_groups.map((e) => e.code).join(", ")
                : ""
            }}
          </template>
          <template #cell(status_registry)="{ item }" v-if="items.length">
            {{ item.status_registry.value === 1 ? "G" : "F" }}
          </template>
          <template #cell(insurance_policy)="{ item }" v-if="items.length">
            <span :class="{ 'text-red': !item.insurance_policies.length }">
              {{
                item.insurance_policies.filter((insurance_policy) =>
                  [0, 1, 2].includes(insurance_policy.status_policy.value)
                ).length
                  ? item.insurance_policies.filter((insurance_policy) =>
                    [0, 1, 2].includes(insurance_policy.status_policy.value)
                  ).length
                  : "no pol"
              }}
            </span>
          </template>
          <template #cell(note_counter)="{ item }" v-if="items.length">
            <div
              :role="
                item.tasks.filter((task) => task.task_type.value === 2).length
                  ? 'button'
                  : null
              "
              class="info-box float-left"
              @click="
                item.tasks.filter((task) => task.task_type.value === 2).length
                  ? openNoteDetailModal(
                      item.tasks.filter((task) => task.task_type.value === 2)
                    )
                  : null
              "
              v-b-tooltip="
                toTooltipTask(
                  item.tasks.filter((task) => task.task_type.value === 2),
                  'Note',
                  [
                    { label: 'Titolo', key: 'title' },
                    { label: 'Descrizione', key: 'description' },
                    {
                      label: 'Ultimo aggiornamento',
                      key: 'last_update',
                      formatter: (val) => {
                        return moment(val).format('DD/MM/YYYY HH:mm:ss');
                      },
                    },
                  ]
                )
              "
            >
              <!-- :title="
                  item.tasks.filter((task) => task.task_type.value === 2).length
                    ? 'Mostra Note'
                    : null
                " -->
              {{
                item.tasks.filter((task) => task.task_type.value === 2).length
              }}
            </div>
          </template>
          <template #cell(broker)="{ item }" v-if="items.length">
            {{
              item.insurance_policies
                ? item.insurance_policies
                  .filter((e) => {
                    return e.broker && e.broker.status_broker.value === 0;
                  })
                  // filtrare solo quelle che si trovano in stati particolari:
                  // 0: non perfezionata,
                  // 1: perfezionata
                  // 2:sospesa
                  .filter((e) => {
                    return (
                      e.status_policy &&
                      [0, 1, 2].includes(e.status_policy.value)
                    );
                  })
                  .map((e) => e.broker.attributables.BUID)
                  .filter((value, index, e) => e.indexOf(value) === index)
                  .join(", ")
                : ""
            }}
          </template>
          <template #cell(email)="{ item }" v-if="items.length">
            <span v-html="extractAddressBookInfo(item, 'MAIL')"></span>
          </template>
          <template #cell(cellulare)="{ item }" v-if="items.length">
            <span v-html="extractAddressBookInfo(item, 'CELL')"></span>
          </template>
          <template #cell(telefono)="{ item }" v-if="items.length">
            <span v-html="extractAddressBookInfo(item, 'PHON')"></span>
          </template>
          <template #cell(document_counter)="{ item }" v-if="items.length">
            <div
              :role="item.documents.length ? 'button' : null"
              class="info-box float-left"
              @click="
                item.documents.length
                  ? openDocumentDetailModal(item.documents)
                  : null
              "
              v-b-tooltip="
                toTooltipTask(item.documents, 'Documenti', [
                  { label: 'Titolo', key: 'title' },
                  { label: 'Descrizione', key: 'note' },
                  {
                    label: 'Ultimo aggiornamento',
                    key: 'last_update',
                    formatter: (val) => {
                      return moment(val).format('DD/MM/YYYY HH:mm:ss');
                    },
                  },
                ])
              "
            >
              <!-- :title="item.documents.length ? 'Mostra Documenti' : null" -->
              {{ item.documents.length }}
            </div>
          </template>
          <template #cell(primary_group)="{ item }" v-if="items.length">
            {{
              item.registry_groups
                ? item.registry_groups.length && item.registry_groups.find(
                  registry_group => registry_group.pivot.primary.value === 'Y'
                ) ? item.registry_groups.find(
                  registry_group => registry_group.pivot.primary.value === 'Y'
                ).code: ""
                : "",
            }}
          </template>
          <template #cell(is_coordinator)="{ item }" v-if="items.length">
            <base-checkbox
              name="is_coordinator"
              class="check"
              v-model="
                item.registry_groups[
                  getRegistryGroupIndex(item.registry_groups)
                ].pivot.is_coordinator.value
              "
              chk_val="Y"
              unchk_val="N"
              @input="
                setIsCoordinator(
                  item.registry_groups[
                    getRegistryGroupIndex(item.registry_groups)
                  ].pivot
                )
              "
            />
            <!-- REVIEW coul be true|false, Y|N depending on backend inplementation -->
          </template>
          <template #cell(communication_type)="{ item }" v-if="items.length">
            <base-select
              label=""
              name="communication_type"
              v-model="
                item.registry_groups[
                  getRegistryGroupIndex(item.registry_groups)
                ].pivot.communication_type.value
              "
              :options="communication_types"
              @select="setCommunicationType"
              @remove="$emit('interaction')"
            />
          </template>
          <template #cell(address)="{ item }">
            <span v-html="toInfoData(item, 'address', 0)"></span>
          </template>
          <template #cell(domicilio)="{ item }">
            <span
              v-html="
                toRelationString(
                  'correspondences',
                  item.correspondences,
                  ['ADDR'],
                  [1]
                )
              "
            ></span>
          </template>
          <template #cell(phon)="{ item }">
            <span
              v-html="
                toRelationString(
                  'address_books',
                  item.address_books,
                  ['PHON'],
                  [0]
                )
              "
            ></span>
          </template>
          <template #cell(mobile)="{ item }">
            <span
              v-html="
                toRelationString(
                  'address_books',
                  item.address_books,
                  ['CELL'],
                  [0]
                )
              "
            ></span>
          </template>
          <template #cell(email1)="{ item }">
            <span
              v-html="
                toRelationString(
                  'address_books',
                  item.address_books,
                  ['MAIL'],
                  [0]
                )
              "
            ></span>
          </template>
          <template #cell(email2)="{ item }">
            <span
              v-html="
                toRelationString(
                  'address_books',
                  item.address_books,
                  ['MAIL'],
                  [1]
                )
              "
            ></span>
          </template>
          <template #cell(pec)="{ item }">
            <span
              v-html="
                toRelationString(
                  'address_books',
                  item.address_books,
                  ['PEC'],
                  [0]
                )
              "
            ></span>
          </template>
          <template #cell(address_books)="{ item }">
            <span
              class="primary-contacts"
              :title="toInfoData(item, 'address_books', null, ' · ')"
              v-html="toInfoData(item, 'primary_contacts', null) || '-'"
            ></span>
          </template>
          <template #cell(relative_types)="{ item }" v-if="items.length">
            <base-select
              label=""
              name="relation_types"
              v-model="item['relation_type_id']"
              :options="getFilteredRelativeTypes(item)"
              @select="onSelectRelationType($event, item)"
              @remove="onRemoveRelationType($event, item)"
            />
          </template>
          <template #cell(relation)="{ item }" v-if="items.length">
            {{
              relativeTypeLabel(item.pivot.relative_type, item)
            }}
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                :disabled="!actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>
              <b-button
                :disabled="!actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id, row.item)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>
              <b-button
                :disabled="!actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>
            </div>
          </template>
          <template #cell(rowSelector)="row">
            <div class="action-buttons">
              <b-button
                size="sm"
                variant="lisaweb"
                @click="onChosen(row.item)"
                class="mt-1 mr-1"
                title="Seleziona"
              >
                Seleziona
              </b-button>
            </div>
          </template>
          <template #cell(rowSelector2)="row">
            <div class="action-buttons">
              <!-- <b-button
                size="sm"
                variant="lisaweb"
                @click="onChosen(row.item, 'rowSelector2')"
                class="mt-1"
                title="Stampa"
                >Stampa
              </b-button> -->
              <b-button
                size="sm"
                variant="lisaweb"
                class="mt-1 mr-1"
                title="Stampa"
                @click="onChosen(row.item, 'rowSelector2')"
              >
                <b-icon icon="printer"></b-icon>
              </b-button>
            </div>
          </template>
          <template #cell(rowSelector3)="row">
            <div class="action-buttons">
              <!-- <ul>
                <li v-for="(document, index) in row.item.documents" :key="index">
                  <b-link
                    href="download"
                    @click.prevent="onChosen(document, 'rowSelector3')"
                  >
                    <span v-html="document.title"></span>
                  </b-link>
                </li>
              </ul> -->
              <b-button
                size="sm"
                variant="lisaweb"
                class="mt-1 mr-1"
                title="Download"
                @click="onChosen(row.item, 'rowSelector3')"
                :disabled="!hasPrivacyDoc(row.item)"
              >
                <b-icon icon="cloud-download"></b-icon>
              </b-button>
            </div>
          </template>
          <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
              </template>
              <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>
      <b-button
        v-if="saveRelationBtn && totalItems"
        type="button"
        @click="saveEvent()"
        variant="outline-lisaweb"
        size="sm"
        class="mt-2 float-right"
        :disabled="!selectedItem"
      >
        Salva
      </b-button>
      <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <!-- :active="index === tabIndex" -->
            <b-tab
              v-for="(tab, index) in tabs"
              :active="index === tabIndex"
              :key="index"
              :title="tab.text"
              @click="setTab(tab, index)"
              title-item-class="lisaweb"
            >
              <button-group-tab> </button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import General from "@/components/wallet/registries/details/General";
import Correspondences from "@/components/wallet/registries/details/Correspondences";
import InsurancePolicy from "@/components/wallet/registries/details/InsurancePolicy";
import InsuranceAncillary from "@/components/wallet/registries/details/InsuranceAncillary";
import Takings from "@/components/wallet/registries/details/Takings";
import Claim from "@/components/wallet/registries/details/Claim";
import Appointments from "@/components/wallet/registries/details/Appointments";
import Todo from "@/components/wallet/registries/details/Todo";
import Notes from "@/components/wallet/registries/details/Notes";
import Group from "@/components/wallet/registries/details/Group";
import Documents from "@/components/wallet/registries/details/Documents";
import Communications from "@/components/wallet/registries/details/Communications";
import Relations from "@/components/wallet/registries/details/Relations";
import Prints from "@/components/wallet/registries/details/Prints";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import BaseRadio from "@/components/form/BaseRadio";
import BaseSelect from "@/components/form/BaseSelect";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
// import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters } from "vuex";
import BaseInputPagination from "@/components/form/BaseInputPagination";
import client from "@/repositories/api";
import moment from "moment";
import { relativeTypeLabel } from "@/utils/relatives";
moment.locale("it");

export default {
  name: "BirthdayRegistriesTable",
  mixins: [StorageGetterMixin],
  extends: template,
  data() {
    return {
      // args: null,
      birthdaysWithInsurancePolicies: [],
      // hasChecks: the recipients selected so far, kept across pages as
      // { id, email, sms }. The shared fetch() empties selectedRows on every
      // call, so the selection must be stored here and restored when the page
      // items change; the channel flags are kept because a selected row may no
      // longer be on the displayed page when the send happens.
      persistedSelected: [],
      relativeTypes: [],
      selectedItem: null,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      tabs: [
        { name: "General", text: "Generale" },
        { name: "Correspondences", text: "Indirizzi" },
        { name: "InsurancePolicy", text: "Polizze" },
        { name: "InsuranceAncillary", text: "Titoli" },
        { name: "Takings", text: "Incassi" },
        { name: "Claim", text: "Sinistri" },
        { name: "Appointments", text: "Appuntamenti" },
        { name: "Notes", text: "Note" },
        { name: "Todo", text: "Attività" },
        { name: "Group", text: "Gruppi" },
        { name: "Documents", text: "Doc" },
        { name: "Communications", text: "Comunicazioni" },
        { name: "Relations", text: "Relazioni" },
        { name: "Prints", text: "Stampe" },
      ],
      selected: "General", // dynamically load selected component in tabs
      modalResourceId: null, // prop for the dynamic components
      tabIndex: 0, // remember last visited tab: set active tab when modal gets opened
      // moved to registry_groups.edit:
      // communication_types: [],
      // communication_type: 4, // capogruppo
      // coordinator: {},
    };
  },
  props: {
    saveRelationBtn: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    gId: { default: null },
    args: { default: null },
    communication_types: { default: [] },
    communication_type: { default: 4 },
    coordinator: { default: {} },
  },
  components: {
    BaseIcon,
    BaseInputPagination,
    General,
    Correspondences,
    InsurancePolicy,
    InsuranceAncillary,
    Takings,
    Claim,
    Appointments,
    // Claim: () => import("@/components/wallet/registries/details/Claim"),
    // Appointments: () =>
    //   import("@/components/wallet/registries/details/Appointments"),
    Notes,
    Group,
    Documents,
    Communications,
    Relations,
    Prints,
    ButtonGroupTab,
    BaseCheckbox,
    BaseRadio,
    BaseSelect,
    Todo,
  },
  created() {
    this.isLoading = true;
    /* */
    const url = `${
      process.env.VUE_APP_BASE_URL
    }/registries?perPage=0&byAttribute[DOB]=%-${moment().format(
      "MM"
    )}-${moment().format("DD")}&byInsuranceStatus=yes`;

    client.get(url).then((response) => {
      // console.log(response);
      this.isLoading = true;
      if (response?.data?.data?.[0])
        response.data.data.forEach((obj) =>
          this.birthdaysWithInsurancePolicies.push(obj.id)
        );
      // this.birthdaysWithInsurancePolicies = JSON.parse(
      //   JSON.stringify(response.data.data)
      // );
      // console.log(
      //   "this.birthdaysWithInsurancePolicies",
      //   this.birthdaysWithInsurancePolicies
      // );
      this.$emit("birthdaysWithInsurancePolicies");
    });
    /* */
  },
  beforeMount() {
    this.isLoading = true;
    this.relativeTypes = this.getRelativeTypes();
    // let gId = this.getGroupId();
    // if (gId) {
    //   if (!this.args) {
    //     this.$set(this, "args", {});
    //   }
    //   // questo solleva un warning, ma ok così
    //   // [Vue warn]: Avoid mutating an injected value directly
    //   // since the changes will be overwritten whenever the provided component
    //   // re-renders. injection being mutated: "args"
    //   this.$set(this.args, "extra", {
    //     runBefore: () => {
    //       this.handleCoordinator(gId);
    //     },
    //   });
    // }
    console.log("beforeCreate Registries");
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("countries"))
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            console.info(
              `background data "${path}countries" fetched correctly`
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          })
      );
    if (!this.hasLoadedResource("councils"))
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {
            console.info(`background data "${path}councils" fetched correctly`);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          })
      );
    if (!this.hasLoadedResource("provinces"))
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {
            console.info(
              `background data "${path}provinces" fetched correctly`
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          })
      );
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          console.log("All promises went through correctly");
          // this.isLoading = false;
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          // this.isLoading = false;
        });
    } /*else {
      // this.isLoading = false;
    }*/
    /* */
    /*
    this.getResources(resources):

    let promises = [];
    promises.push(`${path}countries`);
    promises.push(`${path}provinces`);
    promises.push(`${path}councils`);
    Promise.all(promises)
      .then(() => {
        this.isLoading = false;
      })
      .catch((error) => {
        this.onFailure(error);
      });
    */
    /* */
  },
  watch: {
    items() {
      this.restoreSelection();
    },
  },
  methods: {
    relativeTypeLabel,
    // Reapplies persistedSelected to the currently displayed rows: `check`
    // is not part of the API payload, so it has to be set explicitly to keep it
    // reactive.
    restoreSelection() {
      if (!this.hasChecks) return;
      const selectedIds = this.persistedSelected.map((r) => r.id);
      this.items.forEach((item) => {
        this.$set(item, "check", selectedIds.includes(item.id));
      });
      this.selectedRows = this.allIds.filter((id) => selectedIds.includes(id));
      this.checkAll =
        this.allIds.length > 0 &&
        this.selectedRows.length === this.allIds.length;
    },
    // Whether the row is reachable on the given channel. Mirrors the analyses
    // view, where MAIL/CELL come from the primary address book
    // (status_addressbook 0) and SECONDARY_MAIL/SECONDARY_CELL from the
    // secondary one (status 1): ALTERNATIVE (2) is not part of the view.
    hasChannel(item, channel) {
      const type = channel === "sms" ? "CELL" : "MAIL";
      return (item?.address_books ?? [])
        .filter((e) => [0, 1].includes(e?.status_addressbook?.value))
        .some((e) => `${e?.attributables?.[type] ?? ""}`.trim() !== "");
    },
    toRecipient(item) {
      return {
        id: item.id,
        email: this.hasChannel(item, "email"),
        sms: this.hasChannel(item, "sms"),
      };
    },
    emitSelection() {
      this.$emit("selection-changed", [...this.persistedSelected]);
    },
    onSelectRow(value, index, item) {
      if (item.check) {
        this.persistedSelected = [
          ...this.persistedSelected.filter((r) => r.id !== item.id),
          this.toRecipient(item),
        ];
      } else {
        this.persistedSelected = this.persistedSelected.filter(
          (r) => r.id !== item.id
        );
      }
      this.restoreSelection();
      this.emitSelection();
    },
    onSelectAllRows() {
      // Update the persisted list first: selectAll()/unselectAll() replace
      // this.items, which triggers the watcher restoring from that list.
      if (this.checkAll) {
        this.persistedSelected = [
          ...this.persistedSelected.filter((r) => !this.allIds.includes(r.id)),
          ...this.items.map((item) => this.toRecipient(item)),
        ];
        this.selectAll();
      } else {
        this.persistedSelected = this.persistedSelected.filter(
          (r) => !this.allIds.includes(r.id)
        );
        this.unselectAll();
      }
      this.emitSelection();
    },
    clearSelection() {
      this.persistedSelected = [];
      this.restoreSelection();
      this.emitSelection();
    },
    // Primaria e secondaria, nell'ordine: sono le due rubriche che finiscono
    // nella view delle analisi, quindi la colonna mostra lo stesso recapito che
    // l'invio userebbe. Guardare solo la primaria faceva comparire "-" su
    // clienti che invece ricevono.
    extractAddressBookInfo(item, type) {
      const address_books = item?.address_books;
      if (!address_books || !address_books?.length) return "-";
      const ret =
        [0, 1]
          .map((status) =>
            address_books.find((e) => e?.status_addressbook?.value === status)
          )
          .map((e) => `${e?.attributables?.[type] ?? ""}`.trim())
          .find((v) => v !== "") ?? "-";
      // switch (type) {
      //   case 'MAIL':
      //     found = address_books?.attributables?.MAIL ?? ;
      //     break;
      //   case 'CELL':
      //     break;
      //   case 'PHON':
      //     break;
      //   default:
      //     console.log(`No case found for "extractAddressBookInfo"`);
      //     break;
      // }
      return ret;
    },
    rowClass(item) {
      if (!item || !item?.id) return "";
      return `policies-${
        this.birthdaysWithInsurancePolicies.includes(item.id) ? "1" : "0"
      }`;
    },
    saveEvent() {
      // this.$parent.$emit("saveRelation", this.selectedItem);
      let vm = this.$parent;
      while (vm) {
        vm.$emit("saveRelation", this.selectedItem);
        vm = vm.$parent;
      }
    },
    onSelectRelationType(selectedOption, item) {
      this.selectedItem = item;
      item.check = true;
      this.onRadioSelectRow(selectedOption, null, item);
      this.visible = true;
    },
    onRemoveRelationType(selectedOption, item) {
      item.check = false;
      this.onRadioSelectRow(selectedOption, null, item);
      this.visible = false;
    },
    onRadioSelectRow(value, index, item) {
      // value == value of checkbox (ie. true or false, or whatever is stored in v-model)
      // index == visual index of row (i.e. the index of the row wrt the displayed rows)
      // item == the clicked row item data
      // console.log("onRadioSelectRow");
      if (item.check) {
        if (this.isCheckExclusive) {
          // empty array
          this.selectedRows = [];
          // unselect other evetually selected
          this.unselectAll();
          // reselect this one
          this.items.find((e) => e.id === item.id).check = true;
        }
        // push
        this.selectedRows.push(item.id);
      } else {
        // pop
        this.selectedItem = null;
        this.selectedRows = this.selectedRows.filter((i) => i !== item.id);
        item["relation_type_id"] = null;
      }
      // this sets the global checkbox status (remove if use buttons)
      this.checkAll = false;
    },
    onFailure(error) {
      let errMsg = this.$getErrorMessage(error);
      this.$showSnackbar({
        preset: "error",
        text: `${errMsg}`,
      });
      this.isLoading = false;
    },
    openNoteDetailModal(array) {
      this.$emit("open_note", array);
    },
    openDocumentDetailModal(array) {
      this.$emit("open_document", array);
    },
    // getGroupId() {
    //   let group_id;
    //   const filter = this.$parent.$data.filter;
    //   if (filter && Object.keys(filter).length && filter.byRegistryGroup) {
    //     group_id = filter.byRegistryGroup.id;
    //   }
    //   // se group_id non è null, vedo se c'è un ! davanti, altrimenti ...
    //   return group_id
    //     ? !group_id.toString().startsWith("!")
    //       ? group_id
    //       : group_id.toString().slice(1)
    //     : group_id;
    // },
    getGroupId() {
      return this.gId;
    },
    getRegistryGroupIndex(registry_groups) {
      let group_id = this.getGroupId();
      let ret = -1;
      ret = registry_groups.findIndex((elem) => elem.id == group_id);
      // console.debug("getRegistryGroupIndex ret: ", ret);
      return ret;
    },
    // handleCoordinator(gId) {
    //   // this.isLoading = true;
    //   return this.loadCoordinator(gId);
    // },
    // loadCoordinator(gId) {
    //   const Repo = RepositoryFactory.get("registry");
    //   let queryString = `byGroupCoordinator[id]=${gId}`;
    //   return Repo.index(queryString)
    //     .then((response) => {
    //       // set the coordinator
    //       this.$set(
    //         this,
    //         "coordinator",
    //         response.data.data.length ? response.data.data[0] : {}
    //       );
    //       this.setCommunicationTypes(gId);
    //     })
    //     .catch((error) => {
    //       let errMsg = this.$getErrorMessage(error);
    //       this.$showSnackbar({ preset: "error", text: errMsg });
    //     });
    // },
    // setCommunicationTypes(gId) {
    //   const Repo = RepositoryFactory.get("registry_group");
    //   return Repo.pivot_form(gId, "registry")
    //     .then((response) => {
    //       console.log(response.data.fields.communication_type.options);
    //       // se non c'è il coordinator escludo this.communication_type (id = 4)
    //       this.communication_types =
    //         response.data.fields.communication_type.options.filter((o) =>
    //           !this.coordinator.id ? o.value !== this.communication_type : true
    //         );
    //       // this.isLoading = false;
    //     })
    //     .catch((error) => {
    //       let errMsg = this.$getErrorMessage(error);
    //       this.$showSnackbar({ preset: "error", text: errMsg });
    //     });
    // },
    setIsCoordinator(item) {
      if (item.is_coordinator.value === "Y") {
        // REVIEW coul be true|false, Y|N depending on backend inplementation
        // caller has to clear the check from all but this registry_id
        this.$emit(
          "coordinator",
          item.registry_group_id,
          item.registry_id,
          this.coordinator.id
        );
      } else {
        this.$emit(
          "interaction",
          item.registry_group_id,
          item.registry_id,
          this.coordinator.id
        );
      }
    },
    setCommunicationType(val) {
      // fa solo emit per notificare che è stato scelto qualcosa...
      this.$emit("communication", val);
    },
    customized(item) {
      let c = {};
      c.produttore = item.attributables.PROF;
      if (item.status_registry.value == 0) {
        c.data_di_nascita = item.attributables.DOB;
        c.luogo_di_nascita = this.$store.state.auth.councils.find(
          (e) => e.id == item.attributables.POB
        ).title;
        c.numero_documento = item.attributables.DOCN;
      }
      c.indirizzo = this.toRelationString(
        "correspondences",
        item.correspondences,
        ["ADDR"],
        [0]
      ); // Residenza / Sede Legale = 0
      c.domicilio = this.toRelationString(
        "correspondences",
        item.correspondences,
        ["ADDR"],
        [1]
      ); // Domicilio = 1
      c.indirizzo_alternativo = this.toRelationString(
        "correspondences",
        item.correspondences,
        ["ADDR"],
        [2]
      ); // Indirizzo Alternativo = 2
      let customAttributes = this.convertFromCustomAttributesToFields(
        this.customAttributes()(this.repository)
      );
      Object.keys(customAttributes).forEach((i) => {
        let value = customAttributes[i].key.split(".");
        let label = customAttributes[i].label;
        c[label] = item.attributables[value[value.length - 1]];
      });

      return c;
    },
    getFilteredRelativeTypes(item) {
      return this.relativeTypes.map((relative_type) => {
        return {
          value: relative_type.value,
          text:
            relativeTypeLabel(relative_type, item),
        };
      });
    },
    hasPrivacyDoc(item) {
      let pds = item.documents?.filter((e) => e.document_type.value === 0);
      return pds.length;
    },
    // getPrivacyDoc(item) {

    // },
    onModalHidden() {
      this.setTab({ name: "General", text: "Generale" }, 0);
    },
    ...mapGetters("auth", {
      getRelativeTypes: "relative_types",
    }),
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    coord() {
      if (this.coordinator && this.coordinator.id) {
        return this.coordinator.status_registry.value === 1
          ? `Capogruppo :: ${this.coordinator.attributables.CNAM}`
          : `Capogruppo :: ${this.coordinator.attributables.SURN} ${this.coordinator.attributables.NAME}`;
      } else {
        return "Capogruppo :: nessuno";
      }
    },
    // getGroupId() {
    //   return this.gId;
    // },
  },
};
</script>
<style lang="scss">

/* ROSSO */
tr.policies-0 > td:nth-child(1) {
  background: inherit !important;
  border-left: 5px solid rgba(228, 33, 33, 0.3) !important;
}
/* VERDE */
tr.policies-1 > td:nth-child(1) {
  background: inherit !important;
  border-left: 5px solid rgba(19, 172, 19, 0.4) !important;
}

.text-red {
  color: red;
}
:deep(.check) {
  width: 1px;
  // padding-left: 10px;
}
:deep(.check .form-group) {
  margin-bottom: unset !important;
}
//.modal-body {
//  padding: 1rem;
//}
</style>